var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"c-summary_col",class:{ ['c-summary_col--' + _vm.type] : _vm.type }},[_c('h4',{staticClass:"c-summary_col__name"},[_vm._v(_vm._s(_vm.title))]),_vm._v(" "),_c('table',{staticClass:"c-summary_col__table"},[_c('tbody',[_vm._t("default")],2)])])
}
var staticRenderFns = []

export { render, staticRenderFns }